export const FETCH_NETWORK_REQUEST = 'FETCH_NETWORK_REQUEST';
export const FETCH_NETWORK_SUCCESS = 'FETCH_NETWORK_SUCCESS';
export const FETCH_NETWORK_FAILURE = 'FETCH_NETWORK_FAILURE';

export const UPDATE_NETWORK = 'UPDATE_NETWORK';
export const RESET_NETWORK = 'RESET_NETWORK';
export const RESET_NETWORK_STATES = 'RESET_NETWORK_STATES';

export const SUBMIT_NETWORK_REQUEST = 'SUBMIT_NETWORK_REQUEST';
export const SUBMIT_NETWORK_SUCCESS = 'SUBMIT_NETWORK_SUCCESS';
export const SUBMIT_NETWORK_FAILURE = 'SUBMIT_NETWORK_FAILURE';

export const CHECK_NETWORK_PHONE_REQUEST = 'CHECK_NETWORK_PHONE_REQUEST';
export const CHECK_NETWORK_PHONE_SUCCESS = 'CHECK_NETWORK_PHONE_SUCCESS';
export const CHECK_NETWORK_PHONE_FAILURE = 'CHECK_NETWORK_PHONE_FAILURE';

export const CHECK_NETWORK_RESPONSIBLE_PERSON_PHONE_REQUEST =
  'CHECK_NETWORK_RESPONSIBLE_PERSON_PHONE_REQUEST';
export const CHECK_NETWORK_RESPONSIBLE_PERSON_PHONE_SUCCESS =
  'CHECK_NETWORK_RESPONSIBLE_PERSON_PHONE_SUCCESS';
export const CHECK_NETWORK_RESPONSIBLE_PERSON_PHONE_FAILURE =
  'CHECK_NETWORK_RESPONSIBLE_PERSON_PHONE_FAILURE';

export const CHECK_NETWORK_ZIP_REQUEST = 'CHECK_NETWORK_ZIP_REQUEST';
export const CHECK_NETWORK_ZIP_SUCCESS = 'CHECK_NETWORK_ZIP_SUCCESS';
export const CHECK_NETWORK_ZIP_FAILURE = 'CHECK_NETWORK_ZIP_FAILURE';

export const CLOSE_ADD_PAYMENT_METHOD_NOTIFICATION =
  'CLOSE_ADD_PAYMENT_METHOD_NOTIFICATION';
